import React from 'react'
import { Currency } from '@nominex/nomiswap-sdk'
import tw from 'twin.macro'
import styled from 'styled-components'
import { CurrencyImage } from './CurrencyImage'

const BaseCurrencyImage = styled(CurrencyImage)`
  ${tw`relative flex items-center`}
  &:after {
    content: '';
    z-index: 2;
    ${tw`absolute ring-2 ring-dark-gray inset-0 rounded-full`}
  }
`

export const CurrencyPairImage: React.FC<{
  currencyA: Currency
  currencyB: Currency
  size?: string
  className?: string
  source?: 'nominex' | 'twt'
}> = ({ currencyA, currencyB, size, className, source }) => (
  <div className={`flex items-center -space-x-4 ${className ?? ''}`}>
    <BaseCurrencyImage currency={currencyA} size={size} className="z-[2]" source={source} />
    <CurrencyImage currency={currencyB} size={size} className="z-[1]" source={source} />
  </div>
)
